import {
	Button,
	MenuDivider,
	MenuGroupHeader,
	mergeClasses,
	Radio,
	RadioGroup,
} from "@fluentui/react-components";
import { useIntl } from "react-intl";
import { Flex } from "@/components/atoms/flex";
import { FilterButton } from "@/components/molecules/filterbutton";
import { useInteractionMenuStyle } from "@/components/molecules/interactionMenu/style";
import { useStyle } from "./style";
import { ContactTypeFilterProps, ContactTypeFilterValue } from "./types";

const filterOptions: {
	value: ContactTypeFilterValue;
	labelId: string;
	big: boolean;
}[] = [
	{ value: ContactTypeFilterValue.Internal, labelId: "Contacts.Internal", big: true },
	{ value: ContactTypeFilterValue.External, labelId: "Contacts.External", big: true },
	{ value: ContactTypeFilterValue.All, labelId: "Contacts.All", big: false },
];

export const ContactTypeFilter = (props: ContactTypeFilterProps) => {
	const { value, onChange, disabled } = props;
	const intl = useIntl();
	const menuClasses = useInteractionMenuStyle();
	const classes = useStyle();

	const content = (
		<Flex column className={classes.container}>
			<MenuGroupHeader className={menuClasses.filterGroupHeader}>
				{intl.formatMessage({ id: "InteractionMenu.ShowOnly" })}
				<Button
					appearance="transparent"
					className={menuClasses.cleanButtonSize}
					onClick={() => onChange(ContactTypeFilterValue.All)}
				>
					{intl.formatMessage({ id: "InteractionMenu.Reset" })}
				</Button>
			</MenuGroupHeader>
			<MenuDivider />
			<RadioGroup
				layout="horizontal"
				className={classes.radioGroup}
				value={value}
				disabled={disabled}
				onChange={(_, data) => onChange(data.value as ContactTypeFilterValue)}
			>
				{filterOptions.map((option) => (
					<Radio
						key={option.value}
						value={option.value}
						label={intl.formatMessage({ id: option.labelId })}
						className={mergeClasses(
							option.big ? classes.radioElementBig : classes.radioElementSmall
						)}
					/>
				))}
			</RadioGroup>
		</Flex>
	);

	return (
		<FilterButton
			filterNumber={disabled || value === ContactTypeFilterValue.All ? 0 : 1}
			content={content}
		/>
	);
};
